module.exports =  {
  TITLE: {
  default: 'ค้นหาโรงแรม|ที่พักหลายหมื่นแห่งในเอเชียสามารถจองออนไลน์ได้',
  detail: '|การจองโรงแรม',
  },
  hotel: {
    ROOMS: 'ห้อง',
    GUESTS: 'ผู้เข้าพัก',
    CHECK_IN_NUM: 'ผู้เข้าพัก',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'ผู้ใหญ่',
    SUFFIX_ADULTS: 'ผู้ใหญ่',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'เด็ก',
    SUFFIX_CHILDREN: 'เด็ก',
    CHILD_AGE: 'อายุเด็ก',
    NO_MATCH_TIPS: 'ประเภทห้องด้านล่างไม่ตรงกับจำนวนห้องและผู้เข้าพักที่คุณเลือก',

    Book_Hotel: 'จองโรงแรม',
    Select_your_destination: 'เลือกปลายทางของคุณ',
    Please_enter_your_destination: 'โปรดป้อนปลายทาง/โรงแรมของคุณ',
    Booked_up: 'จองเต็ม',
    Hotel_description: 'คำอธิบายโรงแรม',
    Check_in_date: 'วันเช็คอิน',
    Check_out_date: 'วันเช็คเอาท์',
    Sold_out: 'ขายหมด',
    Non_refundable: 'ไม่สามารถคืนเงินได้',
    reserve: 'จอง',
    Pay_Online: 'ชำระเงินออนไลน์',
    Only_rooms_left_before: 'เหลือเพียง ',
    Only_rooms_left_after: ' ห้อง',
    Cancellation_Policy: 'นโยบายการยกเลิก',
    See_all_prices_before: 'ดูราคาทั้งหมด ',
    See_all_prices_after: 'ราคา',
    Estimated_time_of_arrival: 'เวลาที่คาดว่าจะมาถึง',
    make_your_schedule_well_planned: 'เวลาเป็นตามเขตเวลาท้องถิ่น กรุณาวางแผนตารางการของคุณให้ดีและมาถึงตรงตามเวลา',
    Hotel_Not_Found: 'ไม่พบโรงแรม',
    Please_change_your_search: 'กรุณาเปลี่ยนคำค้นหาของคุณ',
    Submit_an_application: 'ส่งใบสมัคร',
    Hotel_Confirmation: 'การยืนยันโรงแรม',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-คืนพัก',
    Hotel_Booking_Number: 'หมายเลขการจองโรงแรม',
    Online_Payment: 'ชำระเงินออนไลน์',
    The_guest_Room_before: 'ผู้เข้าพัก[ห้อง',
    The_guest_Room_after: ']',
    Contact_number: 'หมายเลขติดต่อ',
    Bring_all_valid_IDs: 'โปรดนำบัตรประจำตัวที่ถูกต้องของผู้เข้าพักทุกคนมาตรวจสอบเมื่อเช็คอิน',
    Hotels_Found_before: '',
    Hotels_Found_after: 'พบโรงแรม',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'โรงแรมที่นำเสนอ (',
    Hotels_Presented_after: ' ทั้งหมด)',
    Please_change_the_dates: 'ห้องไม่พร้อมใช้บริการในวันที่คุณเลือก กรุณาเปลี่ยนวันที่',
    Login: 'เข้าสู่ระบบในแอปเพื่อจองโรงแรม',
    Nights_in_total_before: '',
    Nights_in_total_after: 'คืนทั้งหมด',
    Location: 'ที่ตั้ง',
    Pictures: 'รูปภาพ',
    Description: 'คำอธิบาย',
    Policy: 'นโยบาย',
    Check_in_and_check_out_time: 'เวลาเช็คอินและเช็คเอาท์',
    Check_in_and_Check_out_before: 'เช็คอิน: หลังจาก ',
    Check_in_and_Check_out_center: 'เช็คเอาท์: ก่อน ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'เวลาเช็คอิน',
    Check_out_time: 'เวลาเช็คเอาท์',
    Facility_Service: 'สิ่งอำนวยความสะดวกและบริการ',
    Payment_methods: 'วิธีการชำระเงินที่โรงแรมยอมรับ',
    Hotel_Address: 'ที่อยู่ของโรงแรม',
    Pay_online: 'ชำระเงินออนไลน์',
    Pay_offline: 'ชำระเงินแบบออฟไลน์',
    Night_stay_before: '',
    Night_stay_after: '-คืนพัก,',
    Rooms_total_before: 'ห้อง',
    Rooms_total_after: 'ทั้งหมด',
    Guest_name_must_be_provided: 'ต้องระบุชื่อเต็มของผู้เข้าพักทุกคน',
    Please_fill_in_your_contact_number: 'กรุณากรอกหมายเลขติดต่อของคุณ',
    Select_estimated_time_of_arrival: 'เลือกเวลาที่คาดว่าจะมาถึง',
    Number_of_Rooms: 'จำนวนห้อง',
    Maximum_guests_per_room_before: 'มีได้สูงสุด ',
    Maximum_guests_per_room_after: ' ผู้เข้าพักต่อห้อง',
    Many_Rooms: ' ห้อง',
    Service_Fee_Included: '(รวมภาษีและค่าบริการ)',
    Last_Name: 'นามสกุล',
    First_Name: 'ชื่อ ',
    Room: 'ห้อง',
    Additional_Tax: 'ภาษีเพิ่มเติม',
    Please_inform_the_hotel: 'หากคุณจะมาถึงนอกเวลาที่คาดการณ์กรุณาแจ้งโรงแรมล่วงหน้า',
    Please_inform_the_hotel_first: 'การมาถึงโรงแรมนอกเวลาที่คาดการณ์โดยไม่ติดต่อโรงแรมล่วงหน้าจะส่งผลต่อความพร้อมให้บริการของห้องพักและอาหารเย็น กรุณาแจ้งโรงแรมล่วงหน้าเพื่อยืนยันความพร้อมให้บริการในกรณีนี้',
    Booking_Cancellation: 'ยกเลิกการจอง',
    Reason_of_Cancellation: 'เหตุผลที่ยกเลิก',
    Incorrect_Information_Filled: 'กรอกข้อมูลไม่ถูกต้อง',
    Itinerary_Changed: 'แผนการเดินทางเปลี่ยนแปลง',
    Lower_price_on_other_APP: 'ราคาต่ำกว่าบนแอปพลิเคชันอื่น',
    Low_quality_hotel: 'โรงแรมคุณภาพต่ำ',
    Book_at_a_lower_price: 'จองในราคาที่ต่ำกว่าที่ดุลยพินิจที่เคาน์เตอร์',
    Other: 'อื่น ๆ',
    Please_write_your_reason: 'โปรดระบุเหตุผลของคุณ',
    After_cancellation_done: 'หลังจากยกเลิกเสร็จสิ้น การชำระเงินจะถูกส่งคืนให้กับผู้จ่ายเงินเดิมภายใน 3 วันทำการ',
    How_to_fill_in_the_guest_name: 'วิธีการกรอกชื่อผู้เข้าพัก',
    It_should_be_exactly_the_same: 'โปรดให้ชื่อผู้เข้าพักเป็นภาษาอังกฤษสำหรับการจองโรงแรม ควรเป็นเหมือนกันกับใบรับรองที่นำเสนอเมื่อคุณเช็คอิน',
    How_to_fill_in_a_Chinese_name: 'วิธีการกรอกชื่อภาษาจีน:',
    How_to_fill_in_a_English_name: 'วิธีการกรอกชื่อภาษาอังกฤษ',
    For_example: 'ตัวอย่าง: ถ้าชื่อจีนของคุณคือ "韩梅梅", นามสกุลคือ "Han", ชื่อคือ "Meimei"',
    No_specical_characters: 'อย่าใส่ตัวเลขหรืออักขระพิเศษใด ๆ',
    Name_rule_first: 'นามสกุลมาก่อน ตามด้วยชื่อ และหากมีนามสกุลกลางตามหลังชื่อสองคำ',
    Name_rule_second: 'ตัวอย่าง: Green / Jim Stephanie',
    Details: 'รายละเอียด',
    Pay_now: 'ชำระเงินทันที',
    Hotel: 'โรงแรม',
    Check_in: 'เช็คอิน',
    Car: 'รถ',
	    All_bookings: 'การจองทั้งหมด',
    All: 'ทั้งหมด',
    PROMPT: 'ความสนใจ',

    Search: 'ค้นหา',
    COST_DESCRIPTION: 'รายละเอียดราคา',
    TOTAL: 'รวม',
    SEE_ORDER_INFO_TO: 'ชำระเงิน',
    KONW: 'เข้าใจแล้ว',
    BOOKING_INFORMATION: 'ข้อมูลสำคัญ',
    Book_Now: 'ชำระเงินเดี๋ยวนี้',
    MAP: 'แผนที่',
    CONTACT_INFORMATION: 'ข้อมูลติดต่อ',
    LOADING: 'กำลังโหลด...',
    SORT_FILTER: 'เรียงลำดับ/กรอง',
    SCREENING: 'กรอง',
    SEQUENCE: 'เรียงลำดับ',
    PHONE_ASK: 'โทรถาม',
    ABOVE: 'ข้างต้น',
    SUBMINT_ORDER: 'ส่ง',
    OK: 'ตกลง',
    Order_detail: 'รายละเอียดการสั่งซื้อ',
    BOOKING_INFO: 'ข้อมูลการจอง',
    PAYMENT_AMOUNT: 'จำนวนเงินที่ต้องชำระ',
    Order_time: 'เวลาที่จอง',
    ORDER_NUMBERS: 'หมายเลขการจอง',
    PAY_TYPE: 'วิธีการชำระเงิน',
    BALANCE: 'ยอดคงเหลือ',
    CURRENT_BALANCE_BEGIN: 'ยอดคงเหลือ',
    OVERPLUS_BALANCE_BEGIN: 'ยอดคงเหลือ',
    OTHER_PAYMENT: 'วิธีการชำระเงินอื่น ๆ',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'คลิกที่ "Pay It Now" หมายความว่าคุณยินยอมตามข้อตกลง Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《ข้อตกลงบริการ》',
    PAYMENT_ORDER: 'การชำระเงินในการจอง',
    Total_pay: 'จำนวนเงินทั้งหมด',
    PAY_SUCCESS: 'การชำระเงินได้รับการยอมรับ',
    CHECK_THE_ORDER: 'ตรวจสอบการสั่งซื้อ',
    BACK_TO_INDEX: 'กลับไปที่หน้าหลัก',
    CANCEL: 'ยกเลิก',
    RECOMMED: 'แนะนำ',
    PRICE: 'ราคา',
    HIGH: 'สูง',
    LOW: 'ต่ำ',
    RESET: 'รีเซ็ต',
    SELECT_TIME: 'เลือกวันที่',
    Hotel_guest: 'ผู้เข้าพัก',
    Select: 'กรุณาเลือก',
    Emial_address: 'กรุณาใส่ที่อยู่อีเมล',
    Booking_explan: 'ข้อมูลการจอง',
    VIEW_MORE: 'ดูเพิ่มเติม',
    COLLAPSE: 'ซ่อน',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'เช็คอิน',
    TOURISM_LEAVE_HOTEL: 'เช็คเอาท์',
    arrive: 'ปลายทาง',
    Room_description: 'คำอธิบายห้อง',
    Meals: 'อาหาร',
    Room_Type: 'ประเภทห้อง',
    BOOKING_EXPLANATION: 'ข้อมูลการจอง',
    BOOKING_BUTTON: 'จอง',
    REMIND_SUBMIT_ORDER: 'ดำเนินการต่อ',
    login_now: 'ต้องเข้าสู่ระบบเพื่อจองโรงแรมหรือไม่?',
    the_real_scene: 'รูปภาพเป็นเพียงการอ้างอิงและขึ้นอยู่กับสถานที่จริง',
    Bed: 'เตียง',
    Rooms: 'ห้อง',
    Room_rate: 'อัตราค่าห้อง',
    notified_by_SMS: 'หลังจากทำการจองเสร็จเรียบร้อย คุณจะได้รับการแจ้งเตือนทาง SMS',
    email_notifications: 'ใช้ในการรับการแจ้งเตือนทางอีเมล',
    Booking_deadline: 'วันที่สิ้นสุดการจอง',
    Child: 'เด็ก',
    Additional_notes_about_payment: 'ข้อมูลเพิ่มเติมเกี่ยวกับการชำระเงิน',
    Nights: 'คืน',
    Minimum_nights_before: 'ขั้นต่ำ',
    Minimum_nights_after: 'คืน',
    Size: 'ขนาด',
    Guests: 'ผู้เข้าพัก',
    Room_rate_1: 'อัตราค่าห้อง',
    Tax_service_fee: 'ค่าภาษี/ค่าบริการ',
    Pay_now_1: 'ชำระเงินทันที',
    Filter: 'กรอง',
    Room_rate2: 'อัตราค่าห้อง',
    Show_on_map: 'แสดงบนแผนที่',
    Detail: 'รายละเอียด',
    Room_Detail: 'รายละเอียด',

    TAXES_INCL: 'รวมภาษี',
    SEARCH_EMPTY_TIP: 'ขออภัย ไม่มีห้องพักว่างในวันที่คุณเลือก คุณสามารถ: ค้นหาวันหรือโรงแรมที่แตกต่างหรือ',
    severalNight: 'คืน',
    immediateBooking: 'จองเดี๋ยวนี้',
    Refundable: 'สามารถคืนเงินได้',
    MORE: 'เพิ่มเติม',
    adultsCompany: 'ผู้ใหญ่',
    ServiceTerms: 'ข้อกำหนดและเงื่อนไข',
    roomPlan: 'แผน',
    guestRoom: 'ห้องพัก',
    searchAgain: 'ค้นหาอีกครั้ง',
    roomNight: 'ห้อง/คืน',

    NAME_TXT: 'ชื่อ',
    HOLDER_NAME: 'ชื่อผู้ถือบัตร',
    EXPIRATION_DATE: 'วันที่หมดอายุ',
    FORMAT_TXT: 'รูปแบบ',
    SECURITY_CODE: 'รหัสความปลอดภัย',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'ตัวเลข 3 หลักที่ด้านหลังของบัตร',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 ตัวเลขด้านหน้าของบัตร',
    ENTER_COMPLETE_CARD_NUM: 'กรุณาใส่หมายเลขบัตรทั้งหมด',
    PLEASE_ENTER_HOLDER_NAME: 'กรุณากรอกชื่อผู้ถือบัตร',
    ENTER_SECURITY_CODE: 'กรุณากรอกรหัสความปลอดภัย',
    ENTER_EXPIRATION_DATE: 'กรุณากรอกวันที่หมดอายุ',
    ROOM_DETAILS: 'รายละเอียดห้อง',
    CONDITION_CANCEL: 'สามารถคืนเงินได้',
    CHOOSE_PAYMENT_METHOD: 'การชำระเงิน',
    ORDER_TOTAL_LUMP: 'จำนวนเงินทั้งหมด',
    CREDIT_CARD_NUM: 'หมายเลขบัตรเดบิต/เครดิต',
    MAINLAND_CARD_ONLY: 'บัตรธนาคารที่ออกนอกประเทศจีนเท่านั้น',
    SHUT_DOWN: 'ปิด',
    PROVIDER_FROM_CHINA_BANK: 'บริการชำระเงินโดย B.O.C',

    COUPON: 'คูปอง',
    APPLY_A_COUPON: 'ใช้คูปอง',
    NO_USE: 'ไม่สามารถใช้กับดีลนี้ได้',
    Discard: 'ทิ้ง',
    REDEEM: 'แลก',
    EMPTY_COUPON: 'กรุณาใส่รหัสโปรโมชั่น',
    NOTICE_COUPON: 'สามารถแลกรหัสโปรโมชั่นเพียงรหัสเดียวต่อการจองทุกรายการ โปรโมชั่นจะถูกแลกเมื่อทำการจองแล้ว',


   
  // 早餐包含
  BREAKFAST_INCLUDE: 'อาหารเช้า รวม',
  // 早餐不包含
  BREAKFAST_EXCLUDE: 'อาหารเช้า ไม่รวม',
  // 双人床
  DOUBLE_BED: 'เตียงคู่',
  // 双床
  TWIN_BED: 'เตียงแยก',
  // 免费取消
  FREE_CANCEL: 'ยกเลิกฟรี',
  // 餐饮
  MEALS: 'อาหาร',
  // 评价
  EVALUATION: 'รีวิว',
  // 精选评论
  FEATURED_REVIEWS: 'รีวิวแนะนำ',
  // 所有评论
  ALL_REVIEWS: 'รีวิวทั้งหมด',
  // 总体评价
  OVERALL_EVALUATION: 'รีวิวทั้งหมด',
  // 匿名
  ANONYMOUS: 'นามปากกา',
  // 评价等级列表 1
  EVAL_GENERAL_LIST_1: 'แย่',
  // 评价等级列表 2
  EVAL_GENERAL_LIST_2: 'พอใช้',
  // 评价等级列表 3
  EVAL_GENERAL_LIST_3: 'ปาน',
  // 评价等级列表 4
  EVAL_GENERAL_LIST_4: 'ดี',
  // 评价等级列表 5
  EVAL_GENERAL_LIST_5: 'ดีมาก',
  // 最多可选择9张图片
  MAX_IMAGES_WITH_NINE: 'สามารถเลือกรูปได้สูงสุด 9 รูป',
  // 请选择总体评分
  GRADE_EVAL: 'กรุณาเลือกคะแนนรีวิวทั้งหมด',
  // 距离筛选
  DISTANCE_FILTER: 'ระยะทาง ใกล้-ไกล',
  // 编辑评价
  EDIT_EVALUATION: 'แสดงความคิดเห็น',
  // 前往评价
  GO_TO_EVAL: 'แสดงความคิดเห็น',
  // 评价奖励积分
  EVAL_POINTS_AWARD: 'ความคิดเห็นที่ดีสามารถได้รับ 1000 คะแนน 1000 คะแนน = 10 บาท',
  // 附近相似酒店
  NEARBY_LIKE_HOTEL: 'โรงแรมที่คล้ายกันในบริเวณใกล้เคียง',
  // 到酒店的距离
  DISTANCE_HOTEL: 'ไปที่โรงแรม',
  // 请输入评论
  PLEASE_ENTER_COMMENT: 'ความคิดเห็น',
  // 积分奖励提示
  AWARD_POINTS_TIPS: 'ความคิดเห็นที่ดีที่สุดสามารถได้รับ 1000 คะแนน 1000 = 10 บาท',
  // 匿名评论不会显示您的标志和姓名
  NO_SHOW_ANONYMOUS_AVATAR: 'ความคิดเห็นแบบนามปากกาจะไม่แสดงสัญลักษณ์และชื่อของคุณ',
  // 位置
  LOCATION: 'ตำแหน่ง',
  // 设施
  FACILITY: 'สิ่งอำนวยความสะดวก',
  // 服务
  SERVICE: 'บริการ',
  // 卫生
  HEALTH: 'ความสะอาด',
  // 语言选择
  LANGUAGE_SELECT: 'ภาษา',
  // 评论必须有5〜2000个字符
  LIMIT_COMMENT_TXT: 'รีวิวต้องมี 5 ~ 2000 ตัวอักษร',
  // 分享图片和视频
  SHARE_MEDIA: 'แชร์รูปภาพและวิดีโอ',
  // 结算感叹号
  SETTLEMENT_FEEL: 'ความคิดเห็น',
  // 提交评价
  SUBMIT_EVAL: 'ยืนยัน',
  // 酒店详情
  HOTEL_STR: 'รายละเอียด',
  // 条评价
  EVAL_NUM_AFTER: 'รีวิว',
},
header: {
  // 滑雪度假村
  SKIING: 'รีสอร์ทสกี',
  // 国内电话
  header_internal_call: 'ประเทศจีน：',
  // 国际电话
  header_abroad_call: 'นานาชาติ：',
  // 应用程序下载
  header_app_download: 'แอปมือถือ',
  // 客服电话
  service_telephone: 'บริการลูกค้า',
  // 帐号
  account_number: 'บัญชี',
  // 不是白高尔夫会员吗？
  if_bg_user: 'ไม่ใช่สมาชิก BaiGolf หรือ?',
  // 主页
  home: 'หน้าแรก',
  // 酒店
  hotel: 'โรงแรม',
  // 高尔夫
  Golf: 'กอล์ฟ',
  // 住宿和游玩
  PLAY_STAY: 'Stay & Play',
  // 租车
  RENT_CAR_HOME: 'รถ',
  // 会员中心
  center_user: 'ศูนย์สมาชิก',
  // 我的预订
  header_my_order: 'การจองของฉัน',
  // 非会员订单
  header_notmember_order: 'การจองของแขก',
  // 修改密码
  header_edit_password: 'เปลี่ยนรหัสผ่าน',
  // 登出
  header_logout: 'ออกจากระบบ',
  // 登录
  header_login: 'เข้าสู่ระบบ',
  // 注册
  header_register: 'ลงทะเบียน',
  // 我的积分
  header_point: 'คะแนนของฉัน',
  // 所有语言
  header_all_language: 'ทุกภาษา',
  // 扫码下载应用程序
  down_load_app: 'สแกนรหัส QR เพื่อดาวน์โหลด',
  // 登录折扣提示
  login_discount_tip: 'เข้าสู่ระบบเพื่อรับโบนัสและเพลิดเพลินกับสิทธิประโยชน์ที่คุณได้รับเฉพาะ',
},
footer: {
  // 合作伙伴
  footer_partner: 'พันธมิตร',
  // 关于我们
  footer_about_us: 'เกี่ยวกับเรา',
  // 关于白高尔夫
  footer_about_baigolf: 'เกี่ยวกับ BaiGolf.com',
  // 隐私政策
  footer_privacy_policy: 'นโยบายความเป็นส่วนตัวของ BaiGolf.com',
  // BaiGolf.com 服务条款
  footer_use_of_terms: 'ข้อกำหนดการให้บริการ BaiGolf.com',
  // 联系我们
  footer_contact_us: 'ติดต่อเรา',
  // 网站地图
  footer_sitemap: 'แผนผังเว็บไซต์',
  // 常见问题
  footer_use_of_question: 'คำถามที่พบบ่อย',
  // iOS 系统
  footer_ios_system: 'iOS',
  // Android 系统
  footer_android_system: 'Android',
  // 应用程序下载
  footer_app_load: 'ดาวน์โหลดแอป',
  // 新浪微博
  footer_sina_weibo: 'Sina Weibo',
  // 腾讯微博
  footer_tencent_weibo: 'Tencent microblog',
  // 分享
  footer_share_to: 'แบ่งปัน',
  // 版权信息1
  copyright1: 'บริษัท เทคโนโลยีสารสนเทศ BaiGolf จำกัด ลิขสิทธิ์ ',
  // 版权信息2
  copyright2: 'หมายเลขลงทะเบียน ICP 14070002 ของ Yue',
  // 新闻中心
  news_center: 'ศูนย์ข่าว',
  // 关于白高尔夫
  about_baigolf: 'เกี่ยวกับ BaiGolf',
  // 帮助
  help: 'ช่วยเหลือ',
  // BG 高尔夫管理系统（BGMS）
  management_system: 'BG Golf Management System (BGMS)',
  // 微信公众账号
  wechat_official_account: 'บัญชีเฉพาะทาง WeChat',
  // 下载 BaiGolf 应用程序
  download_baiGolf_app: 'ดาวน์โหลด BaiGolf App',
  // 隐私政策
  privacy_policy: 'นโยบายความเป็นส่วนตัว',
  // BaiGolf.com 服务条款
  use_of_terms: 'ข้อกำหนดการให้บริการ',
  // 积分政策
  footer_integral: 'นโยบายคะแนน',
  // 预订政策
  footer_reserve: 'นโยบายการจอง',
  // 国际电话
  footer_abroad_call: 'นานาชาติ',
  // 国内电话
  footer_internal_call: 'ประเทศจีน'

  }
}



// WEBPACK FOOTER //
// ./src/lang/thai.js